import { ECheckpointActions } from '@/store/checkpointStore/CheckpointStoreTypes'

export const checkpointsFr = {
    actions: {
        eraseDetections:
            'Réinitialiser les détections supprimera toutes les détections actuellement enregistrées. Êtes-vous sûr(e) ?',
        eraseDetectionsTitle: 'Réinitialiser les détections',

        unassignDevice: "Souhaitez-vous dissocier l'appareil {device} ?",
        reassignDevice:
            "Souhaitez-vous réassigner l'appareil {device} au checkpoint {checkpoint} ?",
        reassignDeviceTitle: 'Réassigner un appareil',

        deleteCheckpoint: {
            deleteCheckpointTitle: 'Supprimer le checkpoint',
            deleteCheckpointContent:
                'Êtes-vous sûr(e) de vouloir supprimer ce checkpoint ? Cette action est irréversible.'
        }
    },
    api: {
        error: {
            [ECheckpointActions.CREATE_CHECKPOINT]:
                'Erreur lors de la création du checkpoint {name}',
            [ECheckpointActions.DELETE_CHECKPOINT]:
                'Erreur lors de la suppression du checkpoint {name}',
            [ECheckpointActions.FETCH_CHECKPOINT]: 'Erreur lors de la récupération du checkpoint',
            [ECheckpointActions.FETCH_CHECKPOINTS]:
                'Erreur lors de la récupération des checkpoints',
            [ECheckpointActions.UPDATE_CHECKPOINT]:
                'Erreur lors de la modification du checkpoint {name}',

            [ECheckpointActions.ASSOCIATE_DEVICE]: "Erreur lors de l'association de l'appareil",
            [ECheckpointActions.ERASE_DETECTIONS]: 'Erreur lors de la suppression des détections'
        },
        success: {
            [ECheckpointActions.CREATE_CHECKPOINT]:
                'Création du checkpoint {name} effectuée avec succès !',
            [ECheckpointActions.DELETE_CHECKPOINT]:
                'Suppression du checkpoint {name} effectuée avec succès !',
            [ECheckpointActions.FETCH_CHECKPOINT]:
                'Récupération du checkpoint effectuée avec succès !',
            [ECheckpointActions.FETCH_CHECKPOINTS]:
                'Récupération des checkpoints effectuée avec succès !',
            [ECheckpointActions.UPDATE_CHECKPOINT]:
                'Modification(s) du checkpoint {name} effectuée(s) avec succès !',

            [ECheckpointActions.ASSOCIATE_DEVICE]:
                "Association de l'appareil effectuée avec succès !",
            [ECheckpointActions.ERASE_DETECTIONS]:
                'Suppression des détections effectuée avec succès !'
        }
    },
    buttons: {
        deleteCheckpoint: 'Supprimer le checkpoint',
        forceAssociate: "Forcer l'association",
        hideAll: 'Cacher les checkpoints supplémentaires',
        showAll: 'Montrer tous les checkpoints'
    },
    filters: {
        name: 'Filtrer par nom de checkpoint'
    },

    model: {
        associates: 'Appareils associés',
        comments: 'Commentaire',
        name: 'Nom du checkpoint',
        id: 'Checkpoint ID Hub'
    },
    detail: {
        alreadyAssociatedCheckpoints:
            "Cet appareil est déjà associé à un ou plusieurs checkpoints, confirmer l'association à ce nouveau checkpoint le dissociera de tous les checkpoints suivants :",
        associateDevice: "Associer l'appareil",
        associates: 'Associer un appareil',
        dissociateDevice: "Dissocier l'appareil",
        dissociateDeviceContent: "Êtes-vous sûr(e) de vouloir dissocier l'appareil du checkpoint ?",
        noDeviceAssociated: 'Aucun appareil associé'
    },
    title: {
        actionsTitle: 'Actions',
        associateDeviceTitle: 'Associer des appareils',
        informationsTitle: 'Informations',
        partnerTitle: 'Informations du partenaire'
    }
}
